import * as React from 'react';
import { SVGProps } from 'react';

const SvgBackHeaderIOsOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.209 6.351a1.158 1.158 0 0 1 0 1.698L8.313 10.8h10.424c.698 0 1.263.537 1.263 1.2 0 .663-.566 1.2-1.263 1.2H8.313l2.896 2.752a1.158 1.158 0 0 1 0 1.696 1.31 1.31 0 0 1-1.786 0l-5.053-4.8a1.158 1.158 0 0 1 0-1.697l5.053-4.8a1.31 1.31 0 0 1 1.786 0Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgBackHeaderIOsOutlined;
